import React from "react";
import { AppLayout } from "../../layouts";
import { Sides } from "../../components";

const Dashboard = ({ loginData }) => {
    const rightSide = <></>;

    return (
        <>
            <AppLayout.AppLayoutOne
                leftSide={<Sides.LeftSides loginData={loginData} />}
                rightSide={rightSide}
            />
        </>
    );
};

export default Dashboard;